import { IconNotificationsUnread } from '@hulu-react-style-components/icons';
import { Modal } from 'antd';
import { bem } from 'mission-control-common-components';
import { memo } from 'react';

import { useModal } from '../../../../../hooks/useModal';
import type { AlertFlagProps } from '../AlertCell';
import AlertCell from '../AlertCell/AlertCell';
import { AlertFiled } from '../AlertCell/constants';
import AcknowledgeOmsChanges from './AcknowledgeOmsChanges/AcknowledgeOmsChanges';
type OmsCellProps = {
  id: string;
  unacknowledgedCampaignIds?: string[];
  isOrderTypeSelfService: boolean;
  campaignName?: string;
};
const [block] = bem('acknowledge-oms-changes-container');
const OmsCell = ({
  id,
  unacknowledgedCampaignIds,
  isOrderTypeSelfService,
  campaignName,
}: OmsCellProps): JSX.Element | null => {
  const { isModalOpened, onModalClose, onModalOpen } = useModal();
  if (unacknowledgedCampaignIds?.includes(id) && !isOrderTypeSelfService) {
    const flags: AlertFlagProps[] = [
      {
        id,
        field: AlertFiled.OmsNotification,
        isShown: true,
        icon: <IconNotificationsUnread width={20} height={20} data-testid="oms-alert_icon" />,
        hoverMessage: 'Click to acknowledge changes pushed from OMS.',
      },
    ];
    const handleModalInteraction = (e: React.MouseEvent | React.KeyboardEvent): void => {
      e.stopPropagation();
      e.preventDefault();
      if (e.type === 'click' || (e.type === 'keydown' && (e as React.KeyboardEvent).key === 'Enter')) {
        onModalOpen();
      }
    };
    return (
      <>
        <div
          onClick={(e) => handleModalInteraction(e)}
          onKeyDown={(e) => handleModalInteraction(e)}
          role="button"
          data-testid="oms-alert_cell"
        >
          <AlertCell flags={flags} />
        </div>
        {isModalOpened && (
          <div className={block()} onClick={(e) => e.stopPropagation()}>
            <Modal
              open={isModalOpened}
              data-testid="acknowledge-oms-modal"
              className={block()}
              footer={null}
              onCancel={onModalClose}
              width={1193}
              bodyStyle={{ height: '645px' }}
              mask={true}
            >
              <AcknowledgeOmsChanges name={campaignName ?? ''} id={id} onCancel={onModalClose} />
            </Modal>
          </div>
        )}
      </>
    );
  }
  return null;
};
export default memo(OmsCell);
